import { useMemo } from 'react';

import { getZipCode } from '@/lib/tagging/utils';
import useAppointmentStore from '@/store/AppointmentStore';

const useResolvedZipCode = () => {
  const preSelectedZipCode = useAppointmentStore(
    (state) => state.preSelectedZipCode,
  );

  return useMemo(
    () => preSelectedZipCode || getZipCode(),
    [preSelectedZipCode],
  );
};

export const useContactZipGate = () => {
  const zipCode = useResolvedZipCode();

  return {
    zipCode,
    isPending: !zipCode,
  };
};

export default useResolvedZipCode;
